///////////////////////////////////////////////////////////
// Exported utils functions
///////////////////////////////////////////////////////////

export function sendEmbedApiV1MessageToParent(type, ...args) {
    // Do nothing if not embedded in a parent frame
    if (window.parent === window) {
        return;
    }

    window.parent.postMessage({
        type: `eko.${type}`,
        args,

        embedApiVersion: '1.0',
        embedId: 'walmartpdp',
    }, '*');
}

export function randomStr() {
    return Math.random().toString(36).substring(7);
}

export function removeEkoLogo(ekoPlayerRef) {
    if (ekoPlayerRef) {
        ekoPlayerRef.invoke('ekoshell.setParentContainer', 'EkoLogo', null);
    }
}

export function restoreEkoLogo(ekoPlayerRef) {
    if (ekoPlayerRef) {
        ekoPlayerRef.invoke('ekoshell.setParentContainer', 'EkoLogo', 'root');
    }
}

/**
 * Notify parent frame that an `interactions.report` event has occurred.
 * @export
 * @param {string} id - The element ID of the element that was interacted with
 * @param {object} data - Any additional arbitrary data
 */
export function triggerInteractionsReport(id = 'unknown', data = {}) {
    sendEmbedApiV1MessageToParent('interactions.report', id, data);
}

/**
 * Determine whether the eko video is a template. Currently it's defined by the presence if instanceid query params.
 * @param queryParams the query params of the page
 * @returns {boolean}
 */
export function isTemplate({ queryParams }) {
    return !!queryParams.instanceid;
}
